import { LoadImgs } from './loadImgs';
import { WebpUrl } from './webpUrl';
import pageShow from './pageShow';
function typeEqual(obj, type) {
    return Object.prototype.toString.call(obj) === '[object ' + type + ']';
}
function isFn(obj) {
    return typeEqual(obj, 'Function');
}
function isStr(obj) {
    return typeEqual(obj, 'String');
}
function isObj(obj) {
    return typeEqual(obj, 'Object');
}
function isArray(obj) {
    return typeEqual(obj, 'Array');
}
function isUndefined(obj) {
    return typeEqual(obj, 'Undefined');
}
function isNull(obj) {
    return typeEqual(obj, 'Null');
}
function isVoid(obj) {
    return isUndefined(obj) || isNull(obj);
}
function each(obj, fn, context) {
    if (!obj || !isFn(fn)) {
        return;
    }
    context = context || obj;
    if (isArray(obj)) {
        for (let i = 0, l = obj.length; i < l; i++) {
            if (fn.call(context, obj[i], i, obj) === false) {
                return;
            }
        }
    }
    else if (isObj(obj)) {
        for (let n in obj) {
            if (fn.call(context, obj[n], n, obj) === false) {
                return;
            }
        }
    }
}
/**
 * 防抖函数
 * @param fn
 * @param time
 * @param immediate 是否事件触发时马上执行回调函数
 * @returns
 */
function debounce(fn, time = 300, immediate = true) {
    let timer = null;
    return function (...args) {
        if (timer) {
            clearTimeout(timer);
        }
        if (immediate) {
            const callNow = !timer;
            timer = setTimeout(() => {
                timer = null;
            }, time);
            if (callNow) {
                fn.apply(this, args);
            }
        }
        else {
            timer = setTimeout(() => {
                fn.apply(this, args);
            }, time);
        }
    };
}
/**
 * 节流函数
 * @param fn
 * @param time
 * @param options leading trailing
 * @returns
 */
function throttle(fn, time = 300, { leading = true, trailing = true } = {}) {
    let timer = null;
    let lastArgs;
    return function (...args) {
        lastArgs = args;
        if (!timer) {
            if (leading) {
                lastArgs = undefined;
                fn.apply(this, args);
            }
            timer = setTimeout(() => {
                if (trailing && lastArgs) {
                    // 有lastArgs代表之前函数至少执行了1次
                    lastArgs = undefined;
                    fn.apply(this, args);
                }
                if (leading) {
                    // 当 leading 和 trailing 都开启，保证尾部调用跟下一次调用之前有一个间隔
                    setTimeout(() => {
                        timer = null;
                    }, time);
                }
                else {
                    timer = null;
                }
            }, time);
        }
    };
}
/**
 * 深拷贝
 * @param target 支持对象和数组
 */
function cloneDeep(target) {
    let map = new Map();
    function baseClone(target) {
        if (!isObj(target) && !isArray(target))
            return target;
        if (map.get(target))
            return map.get(target);
        let result = isArray(target) ? [] : {};
        map.set(target, result);
        let keys = Object.keys(target);
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            result[key] = cloneDeep(target[key]);
        }
        return result;
    }
    return baseClone(target);
}
/**
 * 生成xpsid
 */
function createXpsid() {
    let d = Date.now();
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid.replace(/-/g, '');
}
function cleanEmptyKey(obj) {
    const propNames = Object.getOwnPropertyNames(obj);
    for (let i = 0; i < propNames.length; i++) {
        let propName = propNames[i];
        if (obj[propName] === null || obj[propName] === undefined) {
            delete obj[propName];
        }
    }
}
class Chain {
    constructor(fn) {
        this._fn = fn;
        this._nextNode = null;
    }
    // 指定下一个节点
    setNextNode(node) {
        return this._nextNode = node;
    }
    // 传给某个节点
    passRequest(...args) {
        const ret = this._fn(...args);
        if (ret === 'next') {
            return this._nextNode && this._nextNode.passRequest(...args);
        }
        return ret;
    }
}
const webpUrl = new WebpUrl().getWebpUrl;
export { Chain, WebpUrl, };
export default {
    isFn,
    isStr,
    isObj,
    isArray,
    isUndefined,
    isNull,
    isVoid,
    each,
    debounce,
    throttle,
    cloneDeep,
    createXpsid,
    cleanEmptyKey,
    LoadImgs,
    webpUrl,
    pageShow
};
